import { render, staticRenderFns } from "./IristarHeader.vue?vue&type=template&id=66e8dad7&scoped=true&"
import script from "./IristarHeader.vue?vue&type=script&lang=js&"
export * from "./IristarHeader.vue?vue&type=script&lang=js&"
import style0 from "./IristarHeader.vue?vue&type=style&index=0&id=66e8dad7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e8dad7",
  null
  
)

export default component.exports